<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" style="z-index: 99" top="5vh" width="45vw"
    @close="handleClose">
    <audio ref="audioPlayer" src="@/assets/audio.mp3" controls style="display: none" />
    <audio ref="successAudioPlayer" src="@/assets/success.mp3" controls style="display: none" />
    <el-form ref="form" :model="form" label-width="auto" @submit.native.prevent>
      <!-- 包裹单号输入 -->
      <el-form-item label="包裹单号" class="scan-form-item">
        <el-input ref="codeInput" v-model.trim="form.old_kr_code" autocomplete="off" clearable
          placeholder="请扫描或输入包裹单号，按回车确认" class="scan-input" @keyup.enter.native="handleQuery"
          @keyup.space.native="handleSpaceInInput" />
      </el-form-item>

      <!-- 已扫描包裹列表（合箱场景） -->
      <el-form-item v-if="shippingType === 4 || shippingType === 7" label="已扫描包裹">
        <div v-for="(item, index) in scannedPackages" :key="index" class="package-tag">
          {{ item }}
        </div>
        <span v-if="scannedPackages.length === 0" style="color: #999">暂无扫描记录</span>
      </el-form-item>

      <!-- 全部包裹列表（合箱场景）- 已扫描的显示绿色背景 -->
      <el-form-item v-if="shippingType === 4 || shippingType === 7" label="全部包裹">
        <div v-for="(item, index) in allPackageList" :key="index" class="package-tag"
          :class="{ 'package-tag-scanned': isPackageScanned(item) }">
          {{ item }}
          <span v-if="isPackageScanned(item)" class="check-mark">✓</span>
        </div>
        <span v-if="allPackageList.length === 0" style="color: #999">暂无数据</span>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table :data="gridData" @selection-change="handleSelectionChange" style="width: 100%;font-size: 18px;">
      <!-- 多选列（分箱/合箱后分箱场景） -->
      <el-table-column v-if="shippingType === 3 || shippingType === 7" type="selection" width="40" align="center" />

      <!-- 包裹单号 -->
      <el-table-column prop="old_kr_code" align="center" label="包裹单号" />

      <!-- 操作 -->
      <el-table-column label="操作" align="center" fixed="right">
        <template #default="{ $index }">
          <el-button type="text" style="color: #f56c6c" size="small" @click="handleDeleteRow($index)">
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="printLoading" @click="handlePrintSheet">
        打印面单
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  OrderQuickDetail,
  orderNotice,
  combinedBoxCheck,
  orderOutbound,
} from '@/api/xgcApi'

export default {
  name: 'ScanDialog',

  props: {
    korType: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      title: '扫描单号',
      dialogFormVisible: false,
      form: {
        old_kr_code: '',
      },
      gridData: [],
      selectedRows: [],
      shippingType: null,
      scannedPackages: [],
      allPackageList: [],
      combinedOrderId: '',
      tempCode: '',
      isCombinedOrderConfirmed: false,
      printLoading: false,
      isProcessing: false,
      audioPlaying: false,
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleGlobalSpace)
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleGlobalSpace)
  },

  methods: {
    // ==================== 音频相关 ====================

    playSuccessAudio() {
      if (this.audioPlaying) return
      this.audioPlaying = true
      try {
        const audio = this.$refs.successAudioPlayer
        if (audio) {
          audio.currentTime = 0
          audio.play().catch(() => { })
          setTimeout(() => {
            this.audioPlaying = false
          }, 500)
        } else {
          this.audioPlaying = false
        }
      } catch (error) {
        this.audioPlaying = false
      }
    },

    playAudio() {
      if (this.audioPlaying) return
      this.audioPlaying = true
      try {
        const audio = this.$refs.audioPlayer
        if (audio) {
          audio.currentTime = 0
          audio.play().catch(() => { })
          setTimeout(() => {
            this.audioPlaying = false
          }, 500)
        } else {
          this.audioPlaying = false
        }
      } catch (error) {
        this.audioPlaying = false
      }
    },

    getShippingTypeLabel(type) {
      const typeMap = {
        1: '原箱发货',
        3: '分箱发货',
        4: '合箱发货',
        6: '原箱发货',
        7: '合箱后分箱',
      }
      return typeMap[type] || `未知类型(${type})`
    },

    // ==================== 弹窗控制 ====================

    showEdit(row) {
      this.resetAllData()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.focusInput()
      })
    },

    handleClose() {
      this.dialogFormVisible = false
      this.resetAllData()
    },

    resetAllData() {
      this.form = {
        old_kr_code: '',
      }
      this.gridData = []
      this.selectedRows = []
      this.scannedPackages = []
      this.allPackageList = []
      this.combinedOrderId = ''
      this.tempCode = ''
      this.isCombinedOrderConfirmed = false
      this.shippingType = null
      this.isProcessing = false
      this.printLoading = false
      this.audioPlaying = false

      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },

    focusInput() {
      if (this.$refs.codeInput) {
        this.$refs.codeInput.focus()
      }
    },

    // ==================== 辅助方法 ====================

    isPackageScanned(packageCode) {
      return this.scannedPackages.includes(packageCode)
    },

    // ==================== 键盘事件 ====================

    handleGlobalSpace(event) {
      if (event.keyCode === 32 && this.dialogFormVisible) {
        const target = event.target
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          return
        }
        event.preventDefault()
        this.handlePrintSheet()
      }
    },

    handleSpaceInInput(event) {
      event.stopPropagation()
    },

    // ==================== 扫码逻辑 ====================

    handleQuery() {
      const code = this.form.old_kr_code
      if (!code) {
        this.$baseMessage('请输入或扫描包裹单号', 'warning')
        return
      }

      if (this.isProcessing) {
        return
      }

      this.isProcessing = true
      this.getParcelDetail()
    },

    async getParcelDetail() {
      try {
        const code = this.form.old_kr_code
        const res = await OrderQuickDetail({ old_kr_code: code })

        const data = res.data
        const newShippingType = data.shipping_type

        if (this.isCombinedOrderConfirmed && newShippingType !== 4) {
          this.$baseMessage(
            `扫描失败：当前正在扫描合箱订单，不能扫描其他类型的包裹（当前类型：${this.getShippingTypeLabel(newShippingType)}），已扫描 ${this.scannedPackages.length}/${this.allPackageList.length}`,
            'error'
          )
          this.playAudio()
          this.form.old_kr_code = ''
          this.isProcessing = false
          this.focusInput()
          return
        }

        if (this.shippingType !== null && this.shippingType !== newShippingType) {
          this.gridData = []
          this.selectedRows = []
          this.scannedPackages = []
          this.allPackageList = []
          this.combinedOrderId = ''
          this.tempCode = ''
          this.isCombinedOrderConfirmed = false
        }

        this.shippingType = newShippingType

        switch (this.shippingType) {
          case 1:
          case 2:
          case 6:
            await this.handleOriginalBox(data)
            break
          case 3:
            await this.handleSplitBox(data)
            break
          case 4:
            await this.handleCombinedBox(data)
            break
          case 7:
            await this.handleCombinedThenSplit(data)
            break
          default:
            this.$baseMessage(`未知的发货类型: ${this.shippingType}`, 'error')
            this.shippingType = null
        }
        this.form.old_kr_code = ''
        this.focusInput()
        this.isProcessing = false
      } catch (error) {
        console.error('查询包裹失败:', error)
        this.playAudio()
        this.form.old_kr_code = ''
        this.isProcessing = false
        this.focusInput()
      }
    },

    // ==================== 各发货类型处理 ====================

    async handleOriginalBox(data) {
      this.playSuccessAudio()
      const orderIds = [data.id]
      await this.pullAndOutbound(orderIds, {
        code: this.form.old_kr_code,
        type: 1,
      })
    },

    async handleSplitBox(data) {
      this.playSuccessAudio()
      this.gridData = data.fen.map(item => ({
        ...item,
        remark: item.remark || '',
      }))
      this.tempCode = this.form.old_kr_code
      this.$baseMessage(`分箱数据已加载，请选择要出库的包裹`, 'success')
    },

    async handleCombinedBox(data) {
      const currentCode = this.form.old_kr_code

      if (this.isCombinedOrderConfirmed) {
        if (!this.allPackageList.includes(currentCode)) {
          this.$baseMessage(
            `扫描失败：包裹 "${currentCode}" 不属于当前合箱订单，请完成当前订单的扫描（已扫描 ${this.scannedPackages.length}/${this.allPackageList.length}）`,
            'error'
          )
          this.playAudio()
          this.form.old_kr_code = ''
          this.isProcessing = false
          this.focusInput()
          return
        }

        if (this.scannedPackages.includes(currentCode)) {
          this.$baseMessage('该包裹已扫描，请勿重复扫描', 'warning')
          this.isProcessing = false
          this.form.old_kr_code = ''
          this.focusInput()
          this.playAudio()
          return
        }

        this.scannedPackages.push(currentCode)
        this.gridData.push({
          old_kr_code: currentCode,
          remark: '',
          store_status: 1,
        })

        this.playSuccessAudio()
        this.$baseMessage(`扫描成功 (${this.scannedPackages.length}/${this.allPackageList.length})`, 'success')

        if (this.scannedPackages.length === this.allPackageList.length) {
          this.$baseMessage('所有包裹已扫描完成，自动出库', 'success')
          setTimeout(() => {
            this.handleCombinedOutbound()
          }, 500)
        }
        return
      }

      if (!data.old_kr_code || !data.old_kr_code.split(',').filter(Boolean).includes(currentCode)) {
        this.$baseMessage(
          `扫描失败：包裹 "${currentCode}" 不属于该合箱订单，请扫描正确的包裹`,
          'error'
        )
        this.playAudio()
        this.shippingType = null
        this.form.old_kr_code = ''
        this.isProcessing = false
        this.focusInput()
        return
      }

      this.combinedOrderId = data.id
      this.allPackageList = data.old_kr_code.split(',').filter(Boolean)
      this.isCombinedOrderConfirmed = true

      this.scannedPackages.push(currentCode)
      this.gridData.push({
        old_kr_code: currentCode,
        remark: '',
        store_status: 1,
      })

      this.playSuccessAudio()
      this.$baseMessage(`扫描成功 (${this.scannedPackages.length}/${this.allPackageList.length})`, 'success')

      if (this.scannedPackages.length === this.allPackageList.length) {
        this.$baseMessage('所有包裹已扫描完成，自动出库', 'success')
        setTimeout(() => {
          this.handleCombinedOutbound()
        }, 500)
      }
    },

    async handleCombinedThenSplit(data) {
      this.tempCode = data.code

      if (data.old_kr_code) {
        this.allPackageList = data.old_kr_code.split(',').filter(Boolean)
      }

      if (data.fen && data.fen.length > 0) {
        this.gridData = data.fen.map(item => ({
          ...item,
          remark: item.remark || '',
        }))
        this.$baseMessage(`分箱数据已加载，请选择要出库的包裹`, 'success')
      } else {
        const currentCode = this.form.old_kr_code
        if (!this.scannedPackages.includes(currentCode)) {
          this.scannedPackages.push(currentCode)
          this.gridData.push({
            old_kr_code: currentCode,
            remark: '',
          })
        }
      }
    },

    // ==================== 核心：拉单+出库 ====================

    /**
     * 拉单 + 出库（统一入口）
     * 出库成功后清空数据，但不关闭弹窗
     */
    async pullAndOutbound(orderIds, outboundParams) {
      if (!orderIds || orderIds.length === 0) {
        this.$baseMessage('没有可出库的订单', 'warning')
        return
      }

      try {
        this.printLoading = true

        const noticeData = {
          id: orderIds,
          type: 4,
        }
        const noticeRes = await orderNotice(noticeData)

        if (noticeRes.code !== 200) {
          this.$baseMessage(noticeRes.msg || '拉单失败', 'error')
          this.printLoading = false
          return
        }

        const outRes = await orderOutbound(outboundParams)

        if (outRes.code === 200) {
          this.$baseMessage('出库成功', 'success')
          this.$emit('change', orderIds)
          // ✅ 清空数据，但不关闭弹窗
          this.clearDataAfterOutbound()
        } else {
          // this.$baseMessage(outRes.msg || '出库失败', 'error')
        }
        this.printLoading = false
      } catch (error) {
        // console.error('拉单出库失败:', error)
        // this.$baseMessage('操作失败，请重试', 'error')
        this.printLoading = false
      }
    },

    /**
     * 出库成功后清空数据（不关闭弹窗）
     */
    clearDataAfterOutbound() {
      this.gridData = []
      this.selectedRows = []
      this.scannedPackages = []
      this.allPackageList = []
      this.combinedOrderId = ''
      this.tempCode = ''
      this.isCombinedOrderConfirmed = false
      this.shippingType = null

      this.$nextTick(() => {
        this.focusInput()
      })
    },

    // ==================== 分箱场景出库 ====================

    async handleSplitOutbound() {
      if (this.selectedRows.length === 0) {
        this.$baseMessage('请选择要出库的包裹（勾选表格左侧复选框）', 'warning')
        return
      }

      const selectedIds = this.selectedRows.map(item => item.id)

      const remarkMap = {}
      this.gridData.forEach(item => {
        if (item.remark) {
          remarkMap[item.id] = item.remark
        }
      })

      const outboundParams = {
        id: selectedIds,
        code: this.tempCode || this.form.old_kr_code,
        type: selectedIds.length === this.gridData.length ? 1 : 2,
        shipping_type: this.shippingType,
        id_data: remarkMap,
      }

      await this.pullAndOutbound(selectedIds, outboundParams)
    },

    // ==================== 合箱场景出库 ====================

    /**
     * 合箱发货出库
     * 出库成功后清空数据，但不关闭弹窗
     */
    async handleCombinedOutbound() {
      if (this.gridData.length === 0) {
        this.$baseMessage('没有可出库的包裹', 'warning')
        return
      }

      try {
        this.printLoading = true

        const codeList = this.gridData.map(item => item.old_kr_code)

        const checkRes = await combinedBoxCheck({
          order_id: this.combinedOrderId,
          old_kr_code: codeList.join(','),
          type: 4,
        })

        if (checkRes.code !== 200) {
          this.$baseMessage(checkRes.msg || '合箱校验失败', 'error')
          this.printLoading = false
          return
        }

        const noticeData = {
          id: [this.combinedOrderId],
          type: 4,
        }
        const noticeRes = await orderNotice(noticeData)

        if (noticeRes.code !== 200) {
          this.$baseMessage(noticeRes.msg || '拉单失败', 'error')
          this.printLoading = false
          return
        }

        const outboundPromises = this.gridData.map(item => {
          return orderOutbound({
            code: item.old_kr_code,
            type: item.store_status || 1,
            remark: item.remark || '',
          })
        })

        const results = await Promise.all(outboundPromises)

        const hasError = results.some(res => res.code !== 200)
        if (hasError) {
          this.$baseMessage('部分包裹出库失败，请检查', 'error')
          this.printLoading = false
          return
        }

        this.$baseMessage('全部出库成功', 'success')
        this.$emit('change', [this.combinedOrderId])

        // ✅ 清空数据，但不关闭弹窗
        this.clearDataAfterOutbound()

        this.printLoading = false
      } catch (error) {
        console.error('合箱出库失败:', error)
        this.$baseMessage('出库失败，请重试', 'error')
        this.printLoading = false
      }
    },

    // ==================== 打印面单（统一入口） ====================

    async handlePrintSheet() {
      if (this.printLoading || this.isProcessing) {
        return
      }

      if (this.gridData.length === 0) {
        this.$baseMessage('请先扫描包裹', 'warning')
        return
      }

      if (this.shippingType === 3 || this.shippingType === 7) {
        await this.handleSplitOutbound()
        return
      }

      if (this.shippingType === 4) {
        await this.handleCombinedOutbound()
        return
      }

      if (this.shippingType === 1 || this.shippingType === 6) {
        this.$baseMessage('原箱包裹已自动出库', 'info')
        return
      }

      this.$baseMessage('未知的发货类型', 'error')
    },

    // ==================== 表格操作 ====================

    handleSelectionChange(val) {
      this.selectedRows = val
    },

    handleDeleteRow(index) {
      const deletedItem = this.gridData[index]
      this.gridData.splice(index, 1)

      if (this.shippingType === 4 && deletedItem) {
        const idx = this.scannedPackages.indexOf(deletedItem.old_kr_code)
        if (idx > -1) {
          this.scannedPackages.splice(idx, 1)
        }
        if (this.scannedPackages.length === 0) {
          this.isCombinedOrderConfirmed = false
          this.allPackageList = []
          this.combinedOrderId = ''
        }
      }

      if (this.gridData.length === 0) {
        this.shippingType = null
        this.scannedPackages = []
        this.allPackageList = []
        this.combinedOrderId = ''
        this.tempCode = ''
        this.selectedRows = []
        this.isCombinedOrderConfirmed = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: right;
  padding-top: 10px;
}

/* ==================== 弹窗圆角 ==================== */
:deep(.el-dialog) {
  border-radius: 20px;
  overflow: hidden;
}

:deep(.el-dialog__header) {
  border-radius: 20px 20px 0 0;
}

:deep(.el-dialog__footer) {
  border-radius: 0 0 20px 20px;
}

/* ==================== 扫描输入框样式 ==================== */
.scan-form-item {

  /* 标签文字大小 */
  :deep(.el-form-item__label) {
    font-size: 25px !important;
    font-weight: 500;
    line-height: 50px;
    height: 50px;
  }

  /* 输入框整体容器 */
  :deep(.el-form-item__content) {
    line-height: 50px;
  }
}

.scan-input {

  /* 输入框本身 */
  :deep(.el-input__inner) {
    font-size: 25px !important;
    height: 50px !important;
    line-height: 50px !important;
    border-radius: 12px !important;
    padding: 0 20px;
  }

  /* 输入框的清除按钮 */
  :deep(.el-input__suffix) {
    .el-input__suffix-inner {
      .el-input__clear {
        font-size: 20px;
        line-height: 50px;
      }
    }
  }

  /* 输入框的placeholder */
  :deep(.el-input__inner::placeholder) {
    font-size: 20px;
  }
}

/* ==================== 表格样式 - 字体18px ==================== */
:deep(.el-table) {
  font-size: 18px !important;

  /* 表头 */
  .el-table__header-wrapper {
    .el-table__header {
      th {
        .cell {
          font-size: 18px !important;
          font-weight: 600;
        }
      }
    }
  }

  /* 表格体 */
  .el-table__body-wrapper {
    .el-table__body {
      td {
        .cell {
          font-size: 18px !important;
        }
      }
    }
  }

  /* 空状态 */
  .el-table__empty-text {
    font-size: 18px !important;
  }
}

/* 表格内的输入框（备注列） */
:deep(.el-table) {
  .el-input__inner {
    font-size: 18px !important;
    height: 40px !important;
    border-radius: 8px !important;
  }

  .el-input__suffix {
    .el-input__suffix-inner {
      .el-input__clear {
        font-size: 16px;
        line-height: 40px;
      }
    }
  }
}

/* 表格内的开关（部分出库列） */
:deep(.el-table) {
  .el-switch {
    .el-switch__core {
      width: 44px !important;
      height: 24px !important;

      &::after {
        width: 20px !important;
        height: 20px !important;
      }
    }
  }
}

/* 表格内的按钮（操作列） */
:deep(.el-table) {
  .el-button--text {
    font-size: 18px !important;
  }
}

/* 表格多选框 */
:deep(.el-table) {
  .el-checkbox {
    .el-checkbox__inner {
      width: 18px !important;
      height: 18px !important;

      &::after {
        height: 10px !important;
        left: 5px !important;
        top: 1px !important;
        width: 5px !important;
      }
    }
  }
}

/* ==================== 包裹标签样式 ==================== */
.package-tag {
  display: inline-block;
  background: #f0f2f5;
  padding: 4px 12px;
  margin: 4px 8px 4px 0;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  transition: all 0.3s ease;

  &:last-child {
    margin-right: 0;
  }
}

/* 已扫描的包裹 - 绿色背景 */
.package-tag-scanned {
  background: #67c23a !important;
  color: #fff !important;
  position: relative;
  padding-right: 28px;
}

/* 对勾标记 */
.check-mark {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
  font-size: 14px;
}

:deep(.el-table) {
  margin-top: 10px;
}

:deep(.el-table .cell) {
  padding: 0 8px;
}

:deep(.el-switch) {
  .el-switch__core {
    width: 40px !important;
  }
}
</style>